<template>
  <v-container
    id="regular-tables-view"
    fluid
    tag="section"
  >
    <!--<h2 style="text-align:center;background-color:#eeeeee;">{{ $t('Affected Asset Management') }}</h2>-->

    <v-row>
      <v-dialog v-model="dialog_add" persistent max-width="800px" :retain-focus="false">
       
        <AssetForm :asset="{}" :formType="'addForm'" :dialog.sync="dialog_add" />
      </v-dialog>
    </v-row>

    <material-card
      icon="mdi-road-variant"
      icon-small
      title="Road"
      color="primary"
    >
    <!--<material-card
      icon="mdi-road-variant"
      icon-small
      title="Road"
      color="#e67300"
    >-->
      <v-data-table class="asset-table"
        :headers="roadHeaders"
        :items="roads" 
      >
        <template v-for="header in roadHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
    <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>
        <template v-slot:item.km="{ item }">
          <div>{{ item.km_begin }} / {{ item.km_end }}</div>
        </template>
        <template v-slot:item.class="{ item }">
          <div>{{ getTranslation(item.class) }}</div>
        </template>
        <template v-slot:item.category="{ item }">
          <div>{{ getTranslation(item.category) }}</div>
        </template>
        <template v-slot:item.pavement="{ item }">
          <div>{{ getTranslation(item.pavement) }}</div>
        </template>
        <!--<template v-slot:item.details="{ item }">
          <v-btn class="small" color="success" v-on:click="view(item, 'Road')">
            <v-icon>mdi-book-open-blank-variant</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_view" max-width="800px" :retain-focus="false">
            <AssetForm :asset="asset_details" :assetType="'road'" :formType="'viewForm'" :dialog.sync="dialog_view" />
          </v-dialog>
        </template>-->

        <!--<template v-slot:item.drop="{ item }">
          <v-btn class="small" color="primary" v-on:click="drop('Asset', 'Road ' + item.name, item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_delete" max-width="1700px" :retain-focus="false">
            <DeleteForm :type="modal.type" :name="modal.name" :element="modal.element" :dialog.sync="dialog_delete" />
          </v-dialog>
        </template>-->

      </v-data-table>
    </material-card>

    <material-card
      icon="mdi-bridge"
      icon-small
      title="Bridge"
      color="primary"
    >
    <!--<material-card
      icon="mdi-bridge"
      icon-small
      title="Bridge"
      color="#f59e32"
    >-->
      <v-data-table class="asset-table"
        :headers="bridgeHeaders"
        :items="bridges" 
      >
        <template v-for="header in bridgeHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>
        <template v-slot:item.river="{ item }">
          <div>{{ getTranslation(item.river) }}</div>
        </template>
        <template v-slot:item.bridge_type="{ item }">
          <div>{{ getTranslation(item.bridge_type) }}</div>
        </template>
        <!--<template v-slot:item.details="{ item }">
          <v-btn class="small" color="success" v-on:click="view(item, 'Bridge')">
            <v-icon>mdi-book-open-blank-variant</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_view" max-width="800px" :retain-focus="false">
            <AssetForm :asset="asset_details" :assetType="'bridge'" :formType="'viewForm'" :dialog.sync="dialog_view" />
          </v-dialog>
        </template>-->

        <!--<template v-slot:item.drop="{ item }">
          <v-btn class="small" color="primary" v-on:click="drop('Asset', 'Bridge ' + item.name, item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_delete" max-width="1700px" :retain-focus="false">
            <DeleteForm :type="modal.type" :name="modal.name" :element="modal.element" :dialog.sync="dialog_delete" />
          </v-dialog>
        </template>-->

      </v-data-table>
    </material-card>

    <material-card
      icon="mdi-water-pump"
      icon-small
      title="Irrigation"
      color="primary"
    >
    <!--<material-card
      icon="mdi-water-pump"
      icon-small
      title="Irrigation"
      color="#0057d9"
    >-->
      <v-data-table class="asset-table"
        :headers="irrigationHeaders"
        :items="irrigations" 
      >
        <template v-for="header in irrigationHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>
        <template v-slot:item.size="{ item }">
          <div>{{ getTranslation(item.size) }}</div>
        </template>
        <template v-slot:item.irrigation_type="{ item }">
          <div>{{ getTranslation(item.irrigation_type) }}</div>
        </template>
        <template v-slot:item.construction_method="{ item }">
          <div>{{ getTranslation(item.construction_method) }}</div>
        </template>
        <!--<template v-slot:item.details="{ item }">
          <v-btn class="small" color="success" v-on:click="view(item, 'Irrigation')">
            <v-icon>mdi-book-open-blank-variant</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_view" max-width="800px" :retain-focus="false">
            <AssetForm :asset="asset_details" :assetType="'irrigation'" :formType="'viewForm'" :dialog.sync="dialog_view" />
          </v-dialog>
        </template>-->

        <!--<template v-slot:item.drop="{ item }">
          <v-btn class="small" color="primary" v-on:click="drop('Asset', 'Irrigation ' + item.name, item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_delete" max-width="1700px" :retain-focus="false">
            <DeleteForm :type="modal.type" :name="modal.name" :element="modal.element" :dialog.sync="dialog_delete" />
          </v-dialog>
        </template>-->

      </v-data-table>
    </material-card>

    <material-card
      icon="mdi-hospital-box-outline"
      icon-small
      title="Hospital"
      color="primary"
    >
    <!--<material-card
      icon="mdi-hospital-box-outline"
      icon-small
      title="Hospital"
      color="#dc143c"
    >-->
      <v-data-table class="asset-table"
        :headers="hospitalSchoolHeaders"
        :items="hospitals" 
      >
        <template v-for="header in hospitalSchoolHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>
        <template v-slot:item.building_type="{ item }">
          <div>{{ getTranslation(item.building_type) }}</div>
        </template>
        <!--<template v-slot:item.details="{ item }">
          <v-btn class="small" color="success" v-on:click="view(item, 'Hospital')">
            <v-icon>mdi-book-open-blank-variant</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_view" max-width="800px" :retain-focus="false">
            <AssetForm :asset="asset_details" :assetType="'hospital'" :formType="'viewForm'" :dialog.sync="dialog_view" />
          </v-dialog>
        </template>-->

        <!--<template v-slot:item.drop="{ item }">
          <v-btn class="small" color="primary" v-on:click="drop('Asset', 'Hospital ' + item.name, item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_delete" max-width="1700px" :retain-focus="false">
            <DeleteForm :type="modal.type" :name="modal.name" :element="modal.element" :dialog.sync="dialog_delete" />
          </v-dialog>
        </template>-->

      </v-data-table>
    </material-card>

    <material-card
      icon="mdi-school"
      icon-small
      title="School"
      color="primary"
    >
    <!--<material-card
      icon="mdi-school"
      icon-small
      title="School"
      color="#2da14c"
    >-->
      <v-data-table class="asset-table"
        :headers="hospitalSchoolHeaders"
        :items="schools" 
      >
        <template v-for="header in hospitalSchoolHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>
        <template v-slot:item.building_type="{ item }">
          <div>{{ getTranslation(item.building_type) }}</div>
        </template>
        <!--<template v-slot:item.details="{ item }">
          <v-btn class="small" color="success" v-on:click="view(item, 'School')">
            <v-icon>mdi-book-open-blank-variant</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_view" max-width="800px" :retain-focus="false">
            <AssetForm :asset="asset_details" :assetType="'school'" :formType="'viewForm'" :dialog.sync="dialog_view" />
          </v-dialog>
        </template>-->

        <!--<template v-slot:item.drop="{ item }">
          <v-btn class="small" color="primary" v-on:click="drop('Asset', 'School ' + item.name, item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_delete" max-width="1700px" :retain-focus="false">
            <DeleteForm :type="modal.type" :name="modal.name" :element="modal.element" :dialog.sync="dialog_delete" />
          </v-dialog>
        </template>-->

      </v-data-table>
    </material-card>

    <material-card
      icon="mdi-office-building"
      icon-small
      title="Public Building"
      color="primary"
    >
    <!--<material-card
      icon="mdi-office-building"
      icon-small
      title="Public Building"
      color="#8b4513"
    >-->
      <v-data-table class="asset-table"
        :headers="publicBuildingHeaders"
        :items="publicBuildings" 
      >
        <template v-for="header in publicBuildingHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>
        <template v-slot:item.ministry="{ item }">
          <div>{{ getTranslation(item.ministry) }}</div>
        </template>
        <template v-slot:item.building_type="{ item }">
          <div>{{ getTranslation(item.building_type) }}</div>
        </template>
        <!--<template v-slot:item.details="{ item }">
          <v-btn class="small" color="success" v-on:click="view(item, 'Public Building')">
            <v-icon>mdi-book-open-blank-variant</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_view" max-width="800px" :retain-focus="false">
            <AssetForm :asset="asset_details" :assetType="'equipment'" :formType="'viewForm'" :dialog.sync="dialog_view" />
          </v-dialog>
        </template>-->

        <!--<template v-slot:item.drop="{ item }">
          <v-btn class="small" color="primary" v-on:click="drop('Asset', 'Public Building ' + item.name, item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_delete" max-width="1700px" :retain-focus="false">
            <DeleteForm :type="modal.type" :name="modal.name" :element="modal.element" :dialog.sync="dialog_delete" />
          </v-dialog>
        </template>-->

      </v-data-table>
    </material-card>

    <material-card
      icon="mdi-cog"
      icon-small
      title="Equipment"
      color="primary"
    >
    <!--<material-card
      icon="mdi-cog"
      icon-small
      title="Equipment"
      color="#7900c7"
    >-->
      <v-data-table class="asset-table"
        :headers="equipmentHeaders"
        :items="equipments" 
      >
        <template v-for="header in equipmentHeaders" v-slot:[`header.${header.value}`]="{ header }">
          <span>{{ getHeader(header.text) }}</span>
        </template>
        <template v-slot:item.name="{ item }">
          <div>{{ getTranslation(item.name) }}</div>
        </template>
        <template v-slot:item.disaster="{ item }">
          <div>{{ getTranslation(item.disaster) }}</div>
        </template>
        <template v-slot:item.category="{ item }">
          <div>{{ getTranslation(item.category) }}</div>
        </template>
        <!--<template v-slot:item.details="{ item }">
          <v-btn class="small" color="success" v-on:click="view(item, 'Equipment')">
            <v-icon>mdi-book-open-blank-variant</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_view" max-width="800px" :retain-focus="false">
            <AssetForm :asset="asset_details" :assetType="'equipment'" :formType="'viewForm'" :dialog.sync="dialog_view" />
          </v-dialog>
        </template>-->

        <!--<template v-slot:item.drop="{ item }">
          <v-btn class="small" color="primary" v-on:click="drop('Asset', 'Equipment ' + item.name, item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-dialog v-model="dialog_delete" max-width="1700px" :retain-focus="false">
            <DeleteForm :type="modal.type" :name="modal.name" :element="modal.element" :dialog.sync="dialog_delete" />
          </v-dialog>
        </template>-->

      </v-data-table>
    </material-card>

  </v-container>
</template>

<script>
  //import axios from 'axios'
  export default {
    name: 'AssetMgtMap',
    data: () => ({
      roadHeaders: [
        {
          sortable: true,
          text: 'Road ID',
          align: 'center',
          value: 'id',
        },
        {
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
        },
        {
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster',
        },
        {
          sortable: true,
          text: 'KM Begin / End',
          align: 'center',
          value: 'km'
        },
        {
          sortable: true,
          text: 'Width (km)',
          align: 'center',
          value: 'width',
          width: '5%'
        },
        {
          sortable: true,
          text: 'Length (km)',
          align: 'center',
          value: 'length',
          width: '5%'
        },
        {
          sortable: true,
          text: 'Class',
          align: 'center',
          value: 'class',
        },
        {
          sortable: true,
          text: 'Category',
          align: 'center',
          value: 'category',
        },
        {
          sortable: true,
          text: 'Pavement Surface',
          align: 'center',
          value: 'pavement',
          width: '5%'
        },
        {
          sortable: true,
          text: 'Year of Construction',
          align: 'center',
          value: 'construction_year',
          width: '5%'
        },
        /*{
          sortable: false,
          text: 'Details',
          align: 'center',
          value: 'details',
        }*/
      ],
      bridgeHeaders: [
        {
          sortable: true,
          text: 'Bridge ID',
          align: 'center',
          value: 'id',
        },
        {
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
          
        },
        {
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster',
        },
        {
          sortable: true,
          text: 'GPS Location',
          align: 'center',
          value: 'gps_location',
        },
        {
          sortable: true,
          text: 'River',
          align: 'center',
          value: 'river',
        },
        {
          sortable: true,
          text: 'Length (Km)',
          align: 'center',
          value: 'length',
        },
        {
          sortable: true,
          text: 'Surface (Km2)',
          align: 'center',
          value: 'surface',
        },
        {
          sortable: true,
          text: 'Type',
          align: 'center',
          value: 'bridge_type',
        },
        {
          sortable: true,
          text: 'Year of Construction',
          align: 'center',
          value: 'construction_year',
          width: '5%'
        },
        /*{
          sortable: false,
          text: 'Details',
          align: 'center',
          value: 'details',
        }*/
      ],
      irrigationHeaders: [
        {
          sortable: true,
          text: 'Irrigation ID',
          align: 'center',
          value: 'id',
        },
        {
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
        },
         {
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster',
        },
        {
          sortable: true,
          text: 'GPS Location',
          align: 'center',
          value: 'gps_location',
        },
        {
          sortable: true,
          text: 'Length (Km)',
          align: 'center',
          value: 'length',
        },
        {
          sortable: true,
          text: 'Size',
          align: 'center',
          value: 'size',
        },
        {
          sortable: true,
          text: 'Type',
          align: 'center',
          value: 'irrigation_type',
        },
        {
          sortable: true,
          text: 'Year of Construction',
          align: 'center',
          value: 'construction_year',
          width: '5%'
        },
        /*{
          sortable: false,
          text: 'Details',
          align: 'center',
          value: 'details',
        }*/
      ],
      hospitalSchoolHeaders: [
        {
          sortable: true,
          text: 'Number',
          align: 'center',
          value: 'id',
        },
        {
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
        },
         {
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster',
        },
        {
          sortable: true,
          text: 'GPS Location',
          align: 'center',
          value: 'gps_location',
        },
        {
          sortable: true,
          text: 'Type',
          align: 'center',
          value: 'building_type',
        },
        {
          sortable: true,
          text: 'Year of Construction',
          align: 'center',
          value: 'construction_year',
          width: '5%'
        },
        /*{
          sortable: false,
          text: 'Details',
          align: 'center',
          value: 'details',
        }*/
      ],
      publicBuildingHeaders : [
        {
          sortable: true,
          text: 'Number',
          align: 'center',
          value: 'id',
        },
        {
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
        },
         {
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster',
        },
        {
          sortable: true,
          text: 'GPS Location',
          align: 'center',
          value: 'gps_location',
        },
        {
          sortable: true,
          text: 'Ministry',
          align: 'center',
          value: 'ministry',
        },
        {
          sortable: true,
          text: 'Type',
          align: 'center',
          value: 'building_type',
        },
        {
          sortable: true,
          text: 'Year of Construction',
          align: 'center',
          value: 'construction_year',
          width: '5%'
        },
        /*{
          sortable: false,
          text: 'Details',
          align: 'center',
          value: 'details',
        }*/
      ],
      equipmentHeaders: [
        {
          sortable: true,
          text: 'Number',
          align: 'center',
          value: 'id',
        },
        {
          sortable: true,
          text: 'Name',
          align: 'center',
          value: 'name',
        },
         {
          sortable: true,
          text: 'Disaster',
          align: 'center',
          value: 'disaster',
        },
        {
          sortable: true,
          text: 'GPS Location',
          align: 'center',
          value: 'gps_location',
        },
        {
          sortable: true,
          text: 'Category',
          align: 'center',
          value: 'category',
        },
        {
          sortable: true,
          text: 'Year of Acquisition',
          align: 'center',
          value: 'acquisition_year',
          width: '5%'
        },
        /*{
          sortable: false,
          text: 'Details',
          align: 'center',
          value: 'details',
        }*/
      ],
      roads: [
        {
          id: 7001,
          name: '13N',
          //coordinate: '(101.5 , 18.1)',
          km_begin: 101.5,
          km_end: 18.1,
          width: 32,
          length: 105,
          construction_year: 2018,
          work_type: 'Reconstruction',
          disaster: 'Flood 2018',
          year: '2018',
          affected_length: '35KM',
          class: 'National',
          category: 'Semi-Urban',
          pavement: 'Gravel',
          province: 'Vientiane'
        },
        {
          id: 7002,
          name: '13S',
          //coordinate: '(100.3 , 17.5)',
          km_begin: 100.3,
          km_end: 17.5,
          width: 13,
          length: 110,
          construction_year: 2017,
          work_type: 'Emergency Work',
          disaster: 'Tropical Cyclone Dianmu',
          year: '2015',
          affected_length: '3KM',
          class: 'Provincial',
          category: 'Urban',
          pavement: 'Earth',
          province: 'Vientiane'
        }
      ],
      bridges: [
        {
          id: 51,
          name: 'Friendship Bridge',
          river: 'Mekong',
          length: 2,
          surface: 12.2,
          gps_location: '(101.5, 18.1)',
          //latitude: 101.5,
          //longitude: 18.1,
          construction_year: 2017,
          disaster: 'Flood 2018',
          year: '2018',
          bridge_type: 'Concrete',
          province: 'Vientiane'
        }
      ],
      irrigations: [
        {
          id: 11,
          name: 'Irrigation sapanthong village',
          length: 5.2,
          size: 'Large Scheme',
          gps_location: '(101.2, 18.1)',
           disaster: 'Tropical Cyclone Dianmu',
          irrigation_type: 'Reservoir',
          construction_method: 'Ground',
          construction_year: 2017,
          province: 'Vientiane'
        }
      ],
      hospitals: [
        {
          id: 21,
          name: 'Louang Prabang Hospital',
          //latitude: 101.5,
          //longitude: 18.1,
          gps_location: '(101.5, 18.1)',
           disaster: 'Tropical Cyclone Dianmu',
          building_type: 'Ciment',
          construction_year: 2017,
          province: 'Vientiane'
        }
      ],
      schools: [
        {
          id: 31,
          name: 'Savannakhet University',
          //latitude: 101.5,
          //longitude: 18.1,
          gps_location: '(101.5, 18.1)',
          disaster: 'Tropical Cyclone Dianmu',
          building_type: 'Ciment',
          construction_year: 2017,
          province: 'Vientiane'
        }
      ],
      publicBuildings: [
        {
          id: 41,
          name: 'Vientiane Office LAK 40',
          //latitude: 101.5,
          //longitude: 18.1,
          gps_location: '(101.5, 18.1)',
           disaster: 'Flood 2018',
          building_type: 'Ciment',
          ministry: 'MPI - DPI Vientiane Province',
          construction_year: 2017,
          province: 'Vientiane'
        },
        {
          id: 42,
          name: 'Office LAK 11',
          //latitude: 100,
          //longitude: 17.5,
          gps_location: '(100, 17.5)',
           disaster: 'Tropical Cyclone Dianmu',
          building_type: 'Ciment',
          ministry: 'MPI - DPI Bokeo Province',
          construction_year: 2017,
          province: 'Vientiane'
        }
      ],
      equipments: [
        {
          id: 310,
          name: 'Pump 302 - Sapanthong Area',
          //latitude: 101.5,
          //longitude: 18.1,
          gps_location: '(101.5, 18.1)',
           disaster: 'Flood 2018',
          category: 'Irrigation',
          acquisition_year: 2017,
          province: 'Vientiane'
        }
      ],
      dialog_view: false,
      dialog_add: false,
      //dialog_update: false,
      dialog_delete: false,
      asset_details: {},
      modal: {
        type:'',
        name:'',
        element: { disaster_id: 0}
      }
    }),
    /*computed: {
        disasters() {
          return this.$store.state.disasters.disasters;
        }
    },*/
    mounted: function(){
      //this.$store.dispatch('disasters/getDisasters');
    },
    watch: {
      /*dialog_view: function(){
        this.$store.dispatch('disasters/getDisasters');
      },
      dialog_add: function(){
        this.$store.dispatch('disasters/getDisasters');
      },
      dialog_update: function(){
        this.$store.dispatch('disasters/getDisasters');
      },
      dialog_delete: function(){
        this.$store.dispatch('disasters/getDisasters');
      }*/
    },
    methods: {
      getHeader(val) {
        return this.$t(val);
      },
      getTranslation(val) {
        return this.$t(val);
      },
      view: function(asset,type){
        this.dialog_view = true;
        this.asset_details = asset;
        this.asset_details.type = type;
        //this.assetType = type;
      },
      /*update: function(asset,type){
        this.asset_details = asset;
        this.assetType = type;
      },*/
      drop: function(type, name, assetid){
        this.dialog_delete = true;
        this.modal.type = type;
        this.modal.name = name;
        this.modal.element.asset_id = asset_id;
      }
    }
  }
</script>

<style>
  .asset-table > .v-data-table__wrapper > table > tbody > tr > td, 
  .asset-table > .v-data-table__wrapper > table > tbody > tr > th, 
  .asset-table > .v-data-table__wrapper > table > thead > tr > td, 
  .asset-table > .v-data-table__wrapper > table > thead > tr > th, 
  .asset-table > .v-data-table__wrapper > table > tfoot > tr > td, 
  .asset-table > .v-data-table__wrapper > table > tfoot > tr > th {
    padding: 0 5px;
  }
  .small {
    width: 40px;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    min-width: 40px;
  }
</style>
